import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, inject, Ref } from 'vue';

import {
  HeadingDisplay,
  BaseText,
  ContentDisplay,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { SingleInputMoney } from '@/modules/common/components/SingleInputMoney';

import { formatCurrency } from '@/modules/common/helpers/currency';

import { IWithdrawDetails } from '@/modules/transaction/services/variable-income';


export default /*#__PURE__*/_defineComponent({
  __name: 'Withdraw',
  setup(__props) {

const changeAmountValue = inject(
  'changeAmountValue',
  (value: number, formatted: string) => ({ value, formatted })
);

const withdrawDetails = inject('withdrawDetails') as Ref<IWithdrawDetails>;

const amountFormatted = ref('');
const amountValue = ref(0);

const subtitle = computed(() => {
  return `Resgate mínimo: ${withdrawDetails.value.minimumRedemption.formatted}`;
});

const isDisabled = computed(() => {
  return amountValue.value <= 0 || status.value === 'error';
});

const minimumRedemption = computed(() => {
  return withdrawDetails.value.minimumRedemption.value;
});

const totalBalance = computed(() => {
  return withdrawDetails.value.totalBalance.value;
});

const restValue = computed(() => {
  return totalBalance.value - amountValue.value;
});

const maximumRedemption = computed(() => {
  return formatCurrency(
    totalBalance.value - withdrawDetails.value.minimumStayValue.value
  );
});

const status = computed(() => {
  return (amountValue.value < minimumRedemption.value &&
    amountValue.value !== 0) ||
    amountValue.value > totalBalance.value ||
    (restValue.value > 0 && restValue.value < 10000)
    ? 'error'
    : '';
});

const helperText = computed(() => {
  if (amountValue.value < minimumRedemption.value && amountValue.value !== 0)
    return `O valor mínimo de resgate é de ${withdrawDetails.value.minimumRedemption.formatted}. Escolha um valor maior ou igual para resgatar.`;
  if (amountValue.value > totalBalance.value)
    return `O saldo desta carteira é de ${withdrawDetails.value.totalBalance.formatted}. Escolha um valor menor ou igual para resgatar.`;
  if (restValue.value > 0 && restValue.value < 10000)
    return `O valor mínimo de permanência é de ${withdrawDetails.value.minimumStayValue.formatted}. Escolha um valor inferior a R$ ${maximumRedemption.value} ou solicite o resgate total.`;

  return '';
});

function withdrawClick() {
  changeAmountValue(amountValue.value, amountFormatted.value);
}

function onChangeValue(data: { value: number; formatted: string }) {
  amountFormatted.value = data.formatted;
  amountValue.value = data.value;
}

return { __sfc: true,changeAmountValue, withdrawDetails, amountFormatted, amountValue, subtitle, isDisabled, minimumRedemption, totalBalance, restValue, maximumRedemption, status, helperText, withdrawClick, onChangeValue, HeadingDisplay, BaseText, ContentDisplay, ListDisplay, ButtonContainer, ButtonPrimary, NebraskaColors, SingleInputMoney }
}

})